import { Component, Inject } from '@angular/core';

import { VideogularComponent } from '../Videogular.Component';
import { VgStates } from '../VgStates';

import { VBRICK_PLAYER_HOST } from '../../VbPlayerHostToken';

/**
 * Adds a button inside vg-controls to play and pause media.
 *
 * <pre>
 * <videogular>
 *    <vg-media></vg-media>
 *
 *    <vg-controls>
 *        <vg-play-pause-button></vg-play-pause-button>
 *    </vg-controls>
 * </videogular>
 * </pre>
 *
 */
@Component({
	selector: 'vg-play-pause-button',
	template: `
		<button
			[attr.aria-label]="isPlaying ? vbrickPlayer.translations.pause : vbrickPlayer.translations.play"
			type="button"
			[ngClass]="[
				'button',
				isPlaying ? 'pause' : 'vb-icon vb-icon-play-rounded'
			]"
			[tooltip]="playPauseTooltip"
			placement="auto"
			vbControlBarFocus
			(click)="vgApi.playPause()">
		</button>
		<ng-template #playPauseTooltip>
			{{ isPlaying ? vbrickPlayer.translations.pause : vbrickPlayer.translations.play }}
		</ng-template>
		`,
	standalone: false,
	styleUrls: ['./VgPlayPauseButton.Component.ng.less']
})
export class VgPlayPauseButtonComponent {
	constructor(
		@Inject(VBRICK_PLAYER_HOST)
		public vbrickPlayer: any,
		public vgApi: VideogularComponent
	) {}

	public get isPlaying(): boolean {
		return this.vgApi.currentState === VgStates.PLAY;
	}
}
